module.exports = __webpack_public_path__ + "static/media/home-right.50953027.png";